export default "__VITE_ASSET__uxCvk_6g__"